import { useEffect } from "react";
import { toast } from "sonner";
import { applyUpdate } from "@/lib/pwa";

/** Shows "new version available" (user decides when to refresh) and an offline notice. */
export const UpdatePrompt = () => {
  useEffect(() => {
    const onUpdate = (e: Event) => {
      const reg = (e as CustomEvent<ServiceWorkerRegistration>).detail;
      toast("Nova versão disponível", { duration: Infinity, action: { label: "Atualizar", onClick: () => applyUpdate(reg) } });
    };
    const onOffline = () => toast.warning("Sem ligação à internet", { id: "offline" });
    const onOnline = () => toast.success("Ligação restabelecida", { id: "offline", duration: 2500 });
    window.addEventListener("sw-update", onUpdate);
    window.addEventListener("offline", onOffline);
    window.addEventListener("online", onOnline);
    return () => { window.removeEventListener("sw-update", onUpdate); window.removeEventListener("offline", onOffline); window.removeEventListener("online", onOnline); };
  }, []);
  return null;
};
